/* eslint-disable max-statements */
import React from 'react';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close_2.svg';
import Modal from '@conversionProgram/src/Components/Modal';
import Button from '@conversionProgram/src/Components/Button_V2';

const TransactionConfirmModal = ({
  onClose,
  onPress
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "(IMPORTANT) Keep your wallet Safe!"), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.subtitle
  }, "For THC Converting Program's participators only"), /*#__PURE__*/React.createElement("div", {
    className: styles.subtitle
  }, "To keep your wallet safe, you need to follow the popup that appears on the Marketplace. This is a convenient way we created to help you quickly remove acceptance THC Converting Program related content from your Metamask wallet."), /*#__PURE__*/React.createElement("div", {
    className: styles.subtitle
  }, /*#__PURE__*/React.createElement("span", null, "You need to follow this guide as soon as possible to secure your digital assets. Any questions or need help from us, please send a request to us at:\xA0", /*#__PURE__*/React.createElement("a", {
    href: "https://support.thetanarena.com/",
    rel: "noreferrer",
    target: "_blank"
  }, "support.thetanarena.com"))), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "AGREE, Keep my wallet Safe",
    onClick: onPress,
    type: "warning",
    fillWidthAvailable: true
  })))));
};

export default TransactionConfirmModal;